module.exports = __webpack_public_path__ + "img/GCCBrokers-logo.46b568b3.png";